import React, { Component } from 'react';
import TweetParser from '../../utils/TweetParser';
import { MONTHS } from '../../utils/Constants';

class TwitterFeed extends Component {
 
  parseDate = (tdate) => {
    var system_date = new Date(tdate.replace(/^\w+ (\w+) (\d+) ([\d:]+) \+0000 (\d+)$/, "$1 $2 $4 $3 UTC"));
    var month = MONTHS[system_date.getMonth()];       
    var createdDate = system_date.getDate() + ' ' + month + ' ' + system_date.getFullYear();
    return createdDate;
  }
  render(){
    let tweets = this.props.tweets;
    this.parseDate('Fri Oct 27 14:55:08 +0000 2017');
    return(
      <div>
        <h3 className="footer-heading no-margin">
          <i className="fa fa-twitter" aria-hidden="true"></i> What's happening now?
        </h3>
        <div className="small-heading"><a href="https://twitter.com/basildon_online" target="_blank">@basildon_online</a></div>

        { 
          tweets.length > 0 &&
          tweets.map((item, idx) => (
        <div key={idx} className="twitter-item">
          
          <TweetParser
            >{item.text}
            </TweetParser>
            <div className="date">{this.parseDate(item.created_at)}</div>
        </div>
        ))
        }
        <div className="more-link"><a href="https://twitter.com/basildon_online" target="_blank">More...</a></div>
      </div>
    );
  }
}
export default TwitterFeed;


// WEBPACK FOOTER //
// ./src/components/blocks/TwitterFeed.js